import type { ReactElement } from 'react';

import { COLUMNS } from './EventTable';
import { skeletonLine } from '@/components/ui/skeleton';

/** Skeleton contextual que imita la forma de la bitácora (UX-LOAD-01), no un spinner. */
export function TraceabilitySkeleton(): ReactElement {
  return (
    <div className="card rise d2" aria-busy="true" aria-label="Cargando la bitácora">
      <table className="t">
        <thead>
          <tr>
            {COLUMNS.map((c) => (
              <th key={c}>{c}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: 8 }).map((_, r) => (
            <tr key={r}>
              {COLUMNS.map((c, i) => (
                <td key={c}>
                  <div className={skeletonLine({ width: i === 0 ? 'sm' : 80 })} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
